"use client"

import React from "react"

export default function AboutMe() {
  return (
    <main className="min-h-screen bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100">
      <div className="max-w-3xl mx-auto px-4 pt-20 pb-16">
        {/* Heading */}
        <header className="mb-8">
          <h1 className="text-3xl font-semibold tracking-tight">About this demo</h1>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
            PG-HIVE is a schema discovery tool for large property graphs.
            It helps users understand and manage their graph data more effectively.
          </p>
        </header>

        {/* Highlights */}
        <section className="mb-8">
          <h2 className="text-lg font-semibold mb-3">Highlights</h2>
          <ul className="space-y-2">
            <li className="flex gap-3">
              <span className="mt-2 h-2 w-2 rounded-full bg-blue-500" />
              <p>
                Built with <span className="font-medium">PG-HIVE</span> to demonstrate its capabilities on property graph schema discovery.
              </p>
            </li>
            <li className="flex gap-3">
              <span className="mt-2 h-2 w-2 rounded-full bg-emerald-500" />
              <p>
                The absence of an explicit schema makes understanding the data’s structure challenging.
              </p>
            </li>
            <li className="flex gap-3">
              <span className="mt-2 h-2 w-2 rounded-full bg-violet-500" />
              <p>
                We demonstrate PG-HIVE's ability to infer a schema using the following datasets: POLE, MB6, FIB, HET.IO, LDBC, ICIJ, CORD19, and IYP.
              </p>
            </li>

          </ul>
        </section>

      </div>
    </main>
  )
}
